module.exports = __webpack_public_path__ + "static/img/xinyong-icon4.111a44ac.png";